import { gql, useQuery } from '@apollo/client';
import { useContext } from 'react';
import { AppContext } from '@edx/frontend-platform/react';
import { useQuery as useReactQuery } from '@tanstack/react-query';
import { getLearnerCourseSchedules } from '../api/Calendar';

const CUSTOM_EVENTS = gql`
    query FetchEvents {
        events {
            name
            link
            location
            startTime
            endTime
            description
            category
            eventParticipants {
                userId
            }
        }
    }
`;

const eventCategories = {
    'general': 'primary',
    'meeting': 'gray',
    'sprint': 'success',
    'review': 'warning',
    'testing': 'danger',
    'planning': 'info',
}

const useCalendarEvents = (filterUpcoming = false) => {
    const { authenticatedUser } = useContext(AppContext);
    
    const { data: customEvents, loading: customEventsLoading, error: customEventsError } = useQuery(CUSTOM_EVENTS, {
        context: {
            headers: {
                'x-hasura-role': 'learner'
            }
        }
    });

    const { 
        data: courseSchedules, 
        isLoading: courseSchedulesLoading, 
        error: courseSchedulesError 
    } = useReactQuery({
        queryKey: ['learnerCourseSchedules', authenticatedUser?.id],
        queryFn: getLearnerCourseSchedules
    });

    const formatEvents = () => {
        const customScheduledEvents = customEvents?.events?.map(event => ({
            title: event.name,
            start: event.startTime,
            end: event.endTime,
            variant: eventCategories[event.category],
            link: event.link,
            description: event.description
        })) || [];

        const courseSchedulesEvents = courseSchedules?.map(schedule => ({
            title: schedule.assignment_type ? schedule.title : schedule.course_display_name + ' - ' + schedule.title,
            start: schedule.date,
            end: schedule.date,
            variant: schedule.assignment_type ? 'danger' : 'info',
            link: schedule.link,
            linkText: schedule.course_display_name,
            courseName: schedule.course_display_name
        })) || [];

        let allEvents = [...customScheduledEvents, ...courseSchedulesEvents];

        if (filterUpcoming) {
            const now = new Date();
            allEvents = allEvents
                .filter(event => new Date(event.start) >= now)
                .sort((a, b) => new Date(a.start) - new Date(b.start));
        }

        return allEvents;
    };

    return {
        events: formatEvents(),
        loading: customEventsLoading || courseSchedulesLoading,
        error: customEventsError || courseSchedulesError
    };
};

export default useCalendarEvents;